// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3-xYP","header":"ReportDetails_header__1lnf3","title":"ReportDetails_title__1QlHi","left":"ReportDetails_left__3gZBk"};